import TrackingProvider from './TrackingProvider';

export { trackEvent } from './TrackingProvider';
export default TrackingProvider;
